import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { LandLineIcon, MobileIcon, InternetIcon, TvIcon, BundleIcon } from '../Icons';


const NavBarChild = (location, translate, currentLanguage) => {
  const childrenClass = classNames({
    'navbar-nav': true,
    'navbar-child': true,
  });

  const linesMobileClass = classNames({
    'nav-item': true,
    'active': location.pathname.includes("/lines-mobile"),
  });
  const linesFixeClass = classNames({
    'nav-item': true,
    'active': location.pathname.includes("/lines-fixe"),
  });
  const internetClass = classNames({
    'nav-item': true,
    'active': location.pathname.includes("/services/internet"),
  });
  const tvClass = classNames({
    'nav-item': true,
    'active': location.pathname.includes("/services/tv"),
  });
  const bundlesClass = classNames({
    'nav-item': true,
    'active': location.pathname.includes("/services/bundles"),
  });
  const closeNavbar = () => {
    window.jQuery('#top-menu').removeClass('show');
  }
  return (
    <ul className={childrenClass} >
      <li className={linesMobileClass}>
        <Link className="nav-link" to={`/${currentLanguage}/services/lines-mobile`} onClick={() => { closeNavbar() }}>
          <MobileIcon />
          <span className="ng-binding nav-link-text">{translate('mobile')}</span>
        </Link>
      </li>
      <li className={linesFixeClass} >
        <Link className="nav-link" to={`/${currentLanguage}/services/lines-fixe`} onClick={() => { closeNavbar() }}>
          <LandLineIcon />
          <span className="ng-binding nav-link-text">{translate('land-line')}</span>
        </Link>
      </li>
      <li className={internetClass}>
        <Link className="nav-link" ui-sref="services.internet" to={`/${currentLanguage}/services/internet`} onClick={() => { closeNavbar() }}>
          <InternetIcon />
          <span className="ng-binding nav-link-text">{translate('internet')}</span>
        </Link>
      </li>
      <li className={tvClass}>
        <Link className="nav-link" ui-sref="services.tv" to={`/${currentLanguage}/services/tv`} onClick={() => { closeNavbar() }}>
          <TvIcon />
          <span className="ng-binding nav-link-text">{translate('tv-tv')}</span>
        </Link>
      </li>
    </ul>
  );
}

export default NavBarChild;



// WEBPACK FOOTER //
// ./src/components/Navigation/NavBarChild.js